import React, { useEffect } from 'react';
import LZString from 'lz-string';
import CostByYearTable from './cost-by-year-table';
import AdjustmentsTable from './adjustments-table';
import ProratedTableOfCosts from './prorated-table-of-costs';
import ProratedDifferenceFromBaseline from './prorated-difference-from-baseline';

import View from './view';

function Printable() {
  useEffect(() => {
    document.title = 'TrueComp Labor Costing Module';
  });

  const urlParams = new URLSearchParams(window.location.search);
  const printId = urlParams.get('print-id');
  const serializedPrintData = LZString.decompress(
    localStorage.getItem('print-data'),
  );

  if (!serializedPrintData) {
    return <div>Error: no print data</div>;
  }

  const printDataContainer = JSON.parse(serializedPrintData);
  const printData = printDataContainer[printId];

  if (
    printData.chartOverride === 'costByYearTable' ||
    printData.chartOverride === 'differenceFromBaselineTable'
  ) {
    return <CostByYearTable printData={printData} />;
  }
  if (printData.chartOverride === 'proratedDifferenceFromBaselineTable') {
    return <ProratedDifferenceFromBaseline printData={printData} />
  }
  if (printData.chartOverride === 'adjustmentsTable') {
    return <AdjustmentsTable printData={printData} />;
  }
  if (printData.chartOverride === 'proratedCostByYearTable') {
    return <ProratedTableOfCosts printData={printData} />;
  }
  return <View printData={printData} />;
}

export default Printable;
